<template>
  <div class="course-system-block-header">
    <div class="course-system-block-header-title">{{ title }}</div>
    <a v-if="showAction"
       href="https://res.youthmba.com/prod/phpteam/document/Company-profile.pdf">
      <div class="course-system-block-header-right-action">
        查看pdf版本
      </div>
    </a>
  </div>
</template>

<script>
  export default {
    name: 'CourseSystemBlockHeader',
    props: {
      title: {
        type: String,
        required: true,
      },
      showAction: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @main-color: #45bfc0;

  .course-system-block-header {
    box-sizing: border-box;
    padding: 0 @size-large;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-title {
      position: relative;
      padding-left: 25px;
      color: @color-text-base;
      font-size: @font-size-extra-large;
      font-weight: @font-weight-bold;
      line-height: 1;
      &:before {
        position: absolute;
        content: '';
        top: 0;
        left: 0;
        width: @size-extra-small;
        height: @size-medium;
        background: @main-color;
        border-radius: @border-radius-base;
      }
    }

    &-right-action {
      width: 200px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: @main-color;
      font-size: @font-size-small;
      font-weight: @font-weight-bold;
      border: @border-width-base @border-style-base @main-color;
      border-radius: @border-radius-large;
    }
  }

</style>
